import { Observable } from 'rxjs';

import { ReturnOverviewRequest, ReturnOverviewResponse } from '../../model/return-history.model';

export abstract class ReturnOverviewAdapter {
  abstract loadOverview(
    request: ReturnOverviewRequest
  ): Observable<ReturnOverviewResponse>;
}
